var staticParseInt = parseInt

module.exports = staticParseInt



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticParseInt.js
// module id = tgZ/
// module chunks = 137